import React from 'react';

import PropTypes from 'prop-types';

import { ArrowRotateIcon, PhotosIcon, PlayCircleIcon } from '@iris/react-icons';

import { Button } from 'reaxl';

import tabTitles from './tabTitles';

function MediaNavigator({
    onSelectTab = () => {},
    isXs = false,
    isSm = false,
    hasSpin = false,
    photoCount = 0,
    videoCount = 0,
    sliderIndex = 1,
}) {
    let photoButtonLabel;
    if (isXs || isSm) {
        photoButtonLabel = `${sliderIndex} of ${photoCount}`;
    } else {
        photoButtonLabel = `${photoCount} Photo${photoCount > 1 ? 's' : ''}`;
    }

    const videoButtonLabel = `${videoCount} Video${videoCount > 1 ? 's' : ''}`;

    const renderSpinButton = hasSpin && (
        <Button
            bsStyle="text"
            className="margin-right-5"
            id="spin360-btn"
        >
            <ArrowRotateIcon
                className="glyphicon"
            />
            {' '}
            360° Tour
        </Button>
    );

    const renderVideoButton = videoCount > 0 && (
        <Button
            bsStyle="text"
            className="margin-right-5"
            onClick={() => onSelectTab(tabTitles.VIDEOS)}
        >
            <PlayCircleIcon
                className="glyphicon"
            />
            {' '}
            {videoButtonLabel}
        </Button>
    );

    const renderPhotoButton = photoCount > 0 && (
        <Button
            bsStyle="text"
            onClick={() => onSelectTab(tabTitles.IMAGES, 0)}
        >
            <PhotosIcon
                className="glyphicon"
            />
            {' '}
            {photoButtonLabel}
        </Button>
    );

    return (
        <div className={`margin-top-2 ${isXs ? 'text-center' : ''}`}>
            {renderSpinButton}
            {renderVideoButton}
            {renderPhotoButton}
        </div>
    );
}

MediaNavigator.propTypes = {
    onSelectTab: PropTypes.func,
    isXs: PropTypes.bool,
    isSm: PropTypes.bool,
    hasSpin: PropTypes.bool,
    photoCount: PropTypes.number,
    videoCount: PropTypes.number,
    sliderIndex: PropTypes.number,
};

export default MediaNavigator;
